export default "__VITE_ASSET__98EHmtnY__"